import { useTranslation } from 'react-i18next';
import type { SubscriptionNotificationSettings } from '../../api/client';

/** Header-button summary: "1, 3 d before" / "Off". */
export function useNtfSummary(s: SubscriptionNotificationSettings | null) {
  const { t } = useTranslation('paymentsCompact');
  if (!s?.subscription_chat_id) return t('ntf.off');
  return s.advance_days.length ? t('ntf.before', { days: s.advance_days.join(', ') }) : t('ntf.onExpiry');
}
